import _Table from "antd/es/table";
import _Input from "antd/es/input";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import { css } from 'emotion';
import sanitizeHtml from 'sanitize-html';
import OptionInput from '../../common/Question/OptionInput';
var FormItem = _Form.Item;
var OptionInputPC = /*#__PURE__*/function (_Component) {
  _inherits(OptionInputPC, _Component);
  function OptionInputPC() {
    _classCallCheck(this, OptionInputPC);
    return _possibleConstructorReturn(this, _getPrototypeOf(OptionInputPC).apply(this, arguments));
  }
  _createClass(OptionInputPC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        question = _this$props.question,
        label = _this$props.label;
      var custom = question.custom;
      var restrictions = (window.showMultiLang ? question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")] : question.restrictions) || {};
      var optionLabelWidth = custom.optionLabelWidth;
      return React.createElement(OptionInput, this.props, function (_ref) {
        var options = _ref.options,
          error = _ref.error,
          formAnswer = _ref.formAnswer,
          _onChange = _ref.onChange,
          placeholder = _ref.placeholder;
        var required = question.required;
        return React.createElement(FormItem, {
          label: label,
          required: required,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error
        }, React.createElement("div", {
          className: optionInputCls
        }, React.createElement(_Table, {
          showHeader: false,
          columns: [{
            title: '选项',
            dataIndex: 'text',
            width: optionLabelWidth && Number(optionLabelWidth) !== NaN ? "".concat(Number(optionLabelWidth), "%") : 'auto',
            render: function render(text, record) {
              var _record;
              return React.createElement("div", {
                dangerouslySetInnerHTML: {
                  __html: sanitizeHtml(record === null || record === void 0 ? void 0 : (_record = record[window.showMultiLang ? "".concat(window.language, "Text") : 'text']) === null || _record === void 0 ? void 0 : _record.html2Text())
                }
              });
            }
          }, {
            title: '填空',
            dataIndex: 'input',
            render: function render(text, record) {
              return React.createElement("div", null, React.createElement(_Input, {
                suffix: restrictions && restrictions.contentType === 'percent' && '%',
                onChange: function onChange(e) {
                  return _onChange.input(record.id, e.target.value);
                },
                value: ((formAnswer.option_blank || {})[record.id] || [])[0] || '',
                placeholder: placeholder
              }));
            }
          }],
          dataSource: options,
          pagination: false
        })));
      });
    }
  }]);
  return OptionInputPC;
}(Component);
export { OptionInputPC as default };
var optionInputCls = /*#__PURE__*/css(".ant-input{padding-right:30px !important;background:none !important;border-radius:0;border:0;border-bottom:1px solid rgba(22,24,35,0.12);}.ant-input,.ant-input-append{background:none !important;}.ant-input:focus{box-shadow:none !important;}.ant-table-wrapper{width:auto;}.ant-table-tbody > tr > td{padding:12px 6px !important;border-bottom:0 !important;}.ant-table-tbody > tr:hover > td{background:none !important;}.ant-table{table{color:var(--text-color) !important;}}");